<template>
  <span>
      <text-input
          v-for="locale in locales"
          :key="locale"
          :value="innerValue[locale]"
          :name="`${name}_${locale}`"
          :title="`${title} ${locale}`"
          :multiple="multiple"
          :rows="rows"
          :max-length="maxLength"
          :counter="!!maxLength"
          @input="setFieldInput($event, locale)"
      />
  </span>
</template>

<script>
import TextInput from './textInput.vue'

export default {
  name: 'TranslationInput',
  components: {
    TextInput,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: 'translationValue'
    },
    locales: {
      type: Array,
      default: () => ['DE', 'ENG'],
    },
    rows: {
      type: Number,
      default: 3,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      innerValue: {}
    }
  },
  watch: {
    innerValue: {
      handler(innerValue) {
        this.$emit('input', innerValue)
      },
      deep: true
    },
    value(value) {
      this.setInnerValue(value)
    }
  },
  created() {
    this.setInnerValue(this.value)
  },
  methods: {
    setFieldInput(value, locale) {
      this.$set(this.innerValue, locale, value)
    },
    setInnerValue(value) {
      if (value && JSON.stringify(value) !== JSON.stringify(this.innerValue)) {
        this.innerValue = JSON.parse(JSON.stringify(value))
      }
    }
  }
}
</script>